/**
 * PC新首页广告入口
 * @author yongsheng.zhang
 */
const $ = require('jquery')
const midas = require('@dp/midas')

const Domain = location.href.indexOf('51ping') !== -1 ? '//w.51ping.com' : '//www.dianping.com'

let param = {
    cityId: window._DP_HeaderData && window._DP_HeaderData.cityId ? window._DP_HeaderData.cityId : 1
}

const ad = () => {
    $.ajax({
        url: `${Domain}/ajax/brandad`,
        type: 'GET',
        dataType: 'json',
        data: {
            cityId: param.cityId
        }
    })
        .then(result => {
            if (result.status === 'SUCCESS') {
                let $top = $('#top-nav')
                if (result.brandAd && result.brandAd.iconUrl) {
                    let thridClickUrl;
                    let thridPvUrl;
                    if (result.brandAd.monitorClickUrl || result.brandAd.monitorImpUrl) {
                        thridClickUrl = result.brandAd.monitorClickUrl ? result.brandAd.monitorClickUrl : '';
                        thridPvUrl = result.brandAd.monitorImpUrl ? result.brandAd.monitorImpUrl : '';
                    }
                    let adDom = `<div id="ad-index-top" class="ad-index-top" data-midas=${result.brandAd.feedback ? result.brandAd.feedback : ''} data-clickurl=${thridClickUrl} data-impressionurl=${thridPvUrl}>
                                    <a class="ad-index-top-link" href="${result.brandAd.landingPageUrl}" target="_blank" title="${result.brandAd.title ? 'result.brandAd.title' : ''}">
                                        <div class="close-ad"></div>
                                        <img src="${result.brandAd.iconUrl}" class="ad-index-top-pic"/>
                                        <div class="ad-top-tag ${result.brandAd.adMark ? '' : 'Hide'}">${result.brandAd.adMark ? result.brandAd.adMark : ''}</div>
                                    </a>
                                </div>`
                    $top.after(adDom)
                    let $topAd = $('#ad-index-top')
                    $topAd.find('.close-ad').on('click', function(e) {
                        e.stopPropagation()
                        e.preventDefault()
                        $topAd.addClass('hide-top-ad')
                    })
                    // // 打点设置
                    // midas('init');
                }
                midas('init');
            } else if (result.status === 'ERROR') {
                console.log(result.msg)
            } else {
                console.log('ad fail unknow code')
            }
        }, err => {
            if (err) {
                console.log('ad fail error')
            }
        });
}
module.exports = ad



// WEBPACK FOOTER //
// ./src/pages/index/component/ad.js